import { Button } from "components/atoms/button/button";
import { breakpoints, sizes } from "styles";
import styled from "styled-components";

export const PaymentFailedContainer = styled.div<{
  layout: "normal" | "modal";
}>`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 0px 32px 16px;
  padding: 32px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 10px;
  @media ${breakpoints.laptop} {
    justify-content: center;
    ${({ layout, theme }) =>
      layout === "normal" &&
      `width: ${sizes.kredivoPaymentCardWidth.tablet};
    border: 3px solid ${theme.colors.periwinkle[500]};`}
  }
`;

export const ImageAndDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
`;

export const ImageContainer = styled.div`
  height: 220px;
  width: 220px;

  @media ${breakpoints.laptop} {
    height: 220px;
    width: 220px;
  }
`;

export const DetailsContainer = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

export const Heading = styled.h1`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.xl};
  color: ${({ theme }) => theme.colors.neutral[900]};
  margin: 24px 0 0 0;
  @media ${breakpoints.tablet} {
    margin-top: 36px 0 0 0;
    font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  }
`;

export const Subheading = styled.p`
  text-align: center;
  margin: 8px 0 0 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-style: normal;
  font-weight: normal;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.neutral[600]};

  @media ${breakpoints.tablet} {
    margin: 16px 0 0 0;
    font-size: ${({ theme }) => theme.fontSizes["md"]};
  }
`;

export const CTAContainer = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${breakpoints.laptop} {
    margin-top: 40px;
    max-width: 240px;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
  max-width: 280px;
`;

export const LaterCTA = styled.button`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.brand[500]};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  margin-top: 20px;
  border: 0;
`;
export const HelpNeededContainer = styled.div`
  background: ${({ theme }) => theme.colors.neutral[50]};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 12px;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 24px;
`;
export const HelpNeededHeadingContainer = styled.div`
  display: flex;
  gap: 6px;
`;
export const HelpNeededHeading = styled.h4`
  line-height: 28px;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.neutral[900]};

  font-style: normal;
  font-weight: bold;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.lg};
`;

export const HelpNeededSubHeading = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.neutral[500]};

  font-style: normal;
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export const HelpNeededCTA = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => theme.colors.brand[500]};
  cursor: pointer;
`;
